import { memo, useCallback } from 'react'

import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './CopiedText.module.scss'

export interface Props {
  children: string
}

export const CopiedText = memo<Props>(({ children }) => {
  const handleOnClick = useCallback(() => navigator.clipboard.writeText(children), [children])
  return (
    <Tooltip
      textAlign="left"
      className={styles.tooltip}
      viewClassName={styles.viewTooltip}
      tipContent={() => (
        <Button
          className={styles.tooltipButton}
          onClick={handleOnClick}
          variant="text"
          color="white"
        >
          Copy
        </Button>
      )}
    >
      {children}
    </Tooltip>
  )
})
